import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import { Box, Link } from '@mui/material'

import hubIntroImage from '../../assets/hubIntroImage.png'
import {
  IntroButton,
  IntroContentBox,
  IntroImageBox,
  IntroImagesContainer,
  IntroSectionImage,
  IntroSectionWrapper,
  IntroTitle,
  PlusLabel,
  StyledNavigateNextIcon,
} from './index.styles'

interface HubIntroSectionProps {
  title: string
  buttonTitle: string
  onButtonClick?: () => void
  buttonId?: string
  linkHref?: string
}

const HubIntroSection = ({ title, buttonTitle, onButtonClick, linkHref, buttonId }: HubIntroSectionProps) => {
  const { t } = useTranslation()
  return (
    <Box data-testid="hub-intro-section">
      <IntroSectionWrapper>
        <IntroImagesContainer>
          <PlusLabel>{t(translations.PLUS)}</PlusLabel>
          <IntroImageBox>
            <IntroSectionImage src={hubIntroImage} alt="intro-section-image" />
          </IntroImageBox>
        </IntroImagesContainer>
        <IntroContentBox data-testid="hub-intro-section-content">
          <IntroTitle>{title}</IntroTitle>
          {onButtonClick ? (
            <IntroButton onClick={onButtonClick} id={buttonId}>
              {buttonTitle}
              <StyledNavigateNextIcon />
            </IntroButton>
          ) : null}
          {linkHref ? (
            <Link href={linkHref} target="_blank">
              <IntroButton data-testid="hub-intro-section-button" id={buttonId}>
                {buttonTitle}
                <StyledNavigateNextIcon />
              </IntroButton>
            </Link>
          ) : null}
        </IntroContentBox>
      </IntroSectionWrapper>
    </Box>
  )
}

export default HubIntroSection
